const PaymentReg = () => {
  return (
    <section
      className="col-12 ps-3 pe-3"
      style={{ maxWidth: "1000px", margin: "auto" }}
    >
      <p className="text-uppercase text-success fw-bold fs-3 pt-3 text-center">
        Chính sách thanh toán
      </p>
      <p>
        Tã bỉm Mễ Mễ hiện tại không có hình thức thanh toán trực tuyến trên
        website, khách hàng khi đặt mua sản phẩm trên website, nhân viên tư vấn
        sẽ liên hệ lại để xác nhận đơn hàng và hướng dẫn khách hàng có thể lựa
        chọn thanh toán bằng các hình thức sau đây:
      </p>

      <p>
        Cách 1: Thanh toán COD (thanh toán khi nhận hàng). Khách hàng sẽ thanh
        toán đơn hàng cho nhân viên giao vận của đơn vị vận chuyển khi đơn hàng
        được giao tới khách hàng.
      </p>
      <p>
        Cách 2: Thanh toán online qua hình thức chuyển khoản. Khách hàng sẽ
        chuyển khoản thanh toán trước giá trị đơn hàng theo hướng dẫn của nhân
        viên tư vấn, sau đó đơn vị vận chuyển sẽ giao hàng tới cho khách hàng.
      </p>
    </section>
  );
};
export default PaymentReg;
